'use strict';
window.GORGIASCHAT_DISABLE_AUTO_OPEN = true;
const fallback='https://getneuromd.com/?gs_open_chat&gs_chat_page=homepage';
let chatReady;
let selectedDevice='';
const deviceNames={back:'Corrective Therapy Device for Back Pain',whole2:'Whole Body Corrective Therapy Device 2.0',whole:'Whole Body Corrective Therapy Device (original)'};
function loadChat(){
  if(chatReady)return chatReady;
  chatReady=new Promise((resolve,reject)=>{
    let timer;
    const loaded=()=>{clearTimeout(timer);resolve();};
    window.addEventListener('gorgias-widget-loaded',loaded,{once:true});
    timer=setTimeout(()=>{window.removeEventListener('gorgias-widget-loaded',loaded);reject(new Error('Chat did not load'));},15000);
    if(window.GorgiasChat){window.GorgiasChat.init().then(loaded).catch(reject);return;}
    if(!document.getElementById('gorgias-chat-widget-install-v3')){
      const script=document.createElement('script');
      script.id='gorgias-chat-widget-install-v3';
      script.src='https://config.gorgias.chat/bundle-loader/01GYCBPT41R1XRTJJ7H64NXF1V';
      script.async=true;
      script.onerror=()=>{clearTimeout(timer);reject(new Error('Chat unavailable'));};
      document.body.appendChild(script);
    }
  });
  return chatReady;
}
document.addEventListener('click',async(event)=>{
    const button=event.target.closest('[data-chat]');
    if(!button)return;
    const status=document.getElementById('chatStatus');
    status.hidden=false;status.textContent='Opening chat…';
    const original=button.innerHTML;button.disabled=true;button.textContent='Opening chat…';
    try{
      await loadChat();
      await window.GorgiasChat.open();
      // Prefill only. The customer chooses whether to send the message.
      if(typeof window.GorgiasChat.setCurrentInput==='function'){
        const model=deviceNames[selectedDevice] || 'NeuroMD device';
        window.GorgiasChat.setCurrentInput('I bought my '+model+' on Amazon. '+(button.dataset.chat || 'I need troubleshooting help.'));
      }
      status.textContent='Chat is open. Enter your question in the chat window.';
    }catch(error){
      status.innerHTML='Chat couldn’t load here. <a href="'+fallback+'" target="_blank" rel="noopener">Open chat on the NeuroMD website ↗</a> or <a href="mailto:Help@GetNeuroMD.com?subject=Amazon%20device%20support">email our team</a>.';
      status.scrollIntoView({block:'nearest'});
    }finally{button.disabled=false;button.innerHTML=original;}
});

const helpRoot='https://help.getneuromd.com/en-US/';
const wholeTopics=(version)=>[
  {q:'I can’t feel stimulation, or it feels weak',steps:['Check that the electrode is secured to the pod and makes full contact with your skin.','Replace electrodes that have dried out or lost their stickiness.','Adjust the intensity to a comfortable level using your model’s instructions.'],url:version==='2.0'?'weak-stimulation-cannot-feel-stimulation-(wbctd-20)-947815':'weak-stimulation-cannot-feel-stimulation-(wbctd-v1)-319924'},
  {q:'The display light is off',steps:['Press a button to wake the display from its energy-saving state.','If the battery is low, recharge the device.'],url:version==='2.0'?'articles/troubleshooting-(wbctd-20)-212700':'articles/troubleshooting-(wbctd-v1)-92219'},
  {q:'Stimulation starts and stops',steps:['Check which program is selected. Some programs intentionally deliver stimulation intermittently.','If the pattern seems different from your program’s description, ask support before continuing.'],url:version==='2.0'?'intermittent-output-(wbctd-20)-947814':'articles/troubleshooting-(wbctd-v1)-92219'},
  {q:'Stimulation feels uncomfortable',steps:['Stop if stimulation is painful. Lower the intensity and check whether the electrodes are worn.','Review the selected program in your guide. Contact your healthcare provider if discomfort continues.'],url:version==='2.0'?'articles/troubleshooting-(wbctd-20)-212700':'articles/troubleshooting-(wbctd-v1)-92219'}
];
const deviceHelp={
 back:{guide:'articles/corrective-therapy-device-92151',topics:[
  {q:'I feel nothing, or the remote returns to 00',steps:['Clean the skin so it is free of oils, lotions, and sweat. Check that the device is securely connected to the gel pad.','Turn on the device and remote. Look for the connection symbol on the remote.','For the guide’s test, sit down and place the pad 1–3 inches above the knee, with full skin contact. Gradually increase intensity.','If it resets to 00, try a fresh pad and smooth down any lifted edges.'],url:'general-troubleshooting-(for-ctd-only)-180482',video:'https://www.youtube.com/watch?v=NAzZJbRry9Y'},
  {q:'My device or remote won’t charge',steps:['Reconnect the charging cable to both units and to the power source.','Try another USB port or wall adapter.','Swap the two ends of the dual charging cable between the device and remote. This helps identify a faulty cable end.'],url:'device-or-remote-wont-charge-(for-ctd-only)-180486'},
  {q:'The remote won’t connect',steps:['Turn on both units. If they do not pair, try turning on the remote before the device.','A flashing red device light means it needs charging. Check for a solid light and an error-free remote screen.','Attach a fresh or fully sticky electrode and make sure it has complete skin contact before starting stimulation.'],url:'device-and-remote-wont-connect-(for-ctd-only)-180489'}
 ]},
 whole:{guide:'articles/whole-body-corrective-therapy-device-(v1)-91952',topics:[
  {q:'A pod won’t connect to the remote',steps:['Confirm your device is the original Whole Body model. These pairing instructions are specific to version 1.','Open the illustrated pairing guide below. Follow its screen-by-screen instructions to pair and save the pod.'],url:'pod-not-connecting-to-the-remote-(for-wbctd-v1-only)-319945',linkLabel:'Open illustrated pairing steps'},
  ...wholeTopics('1'),
  {q:'How do I set it up for the first time?',steps:['Fully charge the pods and remote before the first session.','Wash and dry the treatment area, leaving it free of oils and lotions.','Secure the pod to the electrode using both magnetic connectors, then follow the quick-start guide to power on and select a program.'],url:'quick-start-guide-(wbctd-v1)-318926',linkLabel:'Open illustrated quick-start guide'}
 ]},
 whole2:{guide:'articles/whole-body-corrective-therapy-device-20-212696',topics:wholeTopics('2.0')},

};
function escapeText(text){return text.replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));}
document.querySelectorAll('[data-device]').forEach(button=>button.addEventListener('click',()=>{
 const value=button.dataset.device,zone=document.getElementById('deviceTopics'),heading=document.getElementById('deviceHeading');
 selectedDevice=value;
 document.querySelectorAll('[data-device]').forEach(card=>{
   const selected=card.dataset.device===value;
   card.setAttribute('aria-pressed',String(selected));
   card.querySelector('.device-pick').textContent=selected?'✓ Selected':'Select device →';
 });
 const device=deviceHelp[value];heading.textContent=deviceNames[value];
 document.getElementById('deviceResults').hidden=false;
 zone.innerHTML=device.topics.map(t=>`<details><summary>${escapeText(t.q)}</summary><div class="answer"><ol>${t.steps.map(s=>'<li>'+escapeText(s)+'</li>').join('')}</ol><div class="article-links"><a href="${helpRoot+t.url}" target="_blank" rel="noopener">${t.linkLabel||'Read the full guide'} ↗</a>${t.video?`<a href="${t.video}" target="_blank" rel="noopener">▶ Watch troubleshooting video</a>`:''}</div><button class="text-button" type="button" data-chat="${escapeText(t.q)}">Still need help? Troubleshooting Support →</button></div></details>`).join('')+`<a class="device-guide" href="${helpRoot+device.guide}" target="_blank" rel="noopener">All guides for this device ↗</a>`;
 renderParts(value);
 heading.focus({preventScroll:true});
 document.getElementById('deviceResults').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
}));

document.getElementById('changeDevice').addEventListener('click',()=>{
 const card=document.querySelector('[data-device="'+selectedDevice+'"]');
 card.focus({preventScroll:true});
 document.querySelector('.device-cards').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
});

// Compatibility checked against the public product catalog, September 22, 2026.
const replacementProducts={
  "butterfly": {
    "title": "Butterfly electrodes",
    "description": "3 butterfly pads per pack.",
    "url": "https://getneuromd.com/products/neuromd-electrode-pads",
    "image": "https://cdn.shopify.com/s/files/1/0201/2450/0032/products/CopyofNewModel_1_4a4b5afd-e4f8-4de7-9931-77f6ab7bcff8.png?v=1720018524&width=400"
  },
  "square": {
    "title": "Square electrodes",
    "description": "4 square pads per pack.",
    "url": "https://getneuromd.com/products/neuromd-square-replacement-pads",
    "image": "https://cdn.shopify.com/s/files/1/0201/2450/0032/files/WBCTD2.0_Square_Electrode_Pads.png?v=1730299361&width=400"
  },
  "backRemote": {
    "title": "USB-C remote · V4",
    "description": "For CTD devices ordered after July 4, 2023. Check your charge port and version.",
    "url": "https://getneuromd.com/products/v4-usb-c-remote-replacement-for-devices-ordered-after-06-04-2023",
    "image": "https://cdn.shopify.com/s/files/1/0201/2450/0032/files/CTDremoteUSBC-min_7c87fde0-490f-4318-9066-86c3d270256b.png?v=1720018828&width=400"
  },
  "backPod": {
    "title": "USB-C device pod · V4",
    "description": "For CTD devices ordered after July 4, 2023. Check your charge port and version.",
    "url": "https://getneuromd.com/products/v4-usbc-corrective-therapy-device-replacement-part-devices-purchased-after-07-04-2023",
    "image": "https://cdn.shopify.com/s/files/1/0201/2450/0032/files/USB-CDevice_1_e12a6f50-eb1e-49d1-a6b5-3027a952a3cb.png?v=1720018836&width=400"
  },
  "backCable": {
    "title": "USB-C charging cable · V4",
    "description": "Double-ended cable for V4 devices and remotes with USB-C ports.",
    "url": "https://getneuromd.com/products/double-ended-usbc-charging-cable-v4",
    "image": "https://cdn.shopify.com/s/files/1/0201/2450/0032/products/V3doubleendedChargingcable_b88dab51-f8da-4771-9aa2-4c4b499904a5.png?v=1720018499&width=400"
  },
  "wholePads": {
    "title": "Original Whole Body electrodes",
    "description": "Choose butterfly, square, or a mixed set. For original WBCTD only.",
    "url": "https://getneuromd.com/products/pad-replacement-for-whole-body-corrective-therapy-device",
    "image": "https://cdn.shopify.com/s/files/1/0201/2450/0032/files/Pouchreorder-Combinedimage_Front_Only_Butteflies.png?v=1720018761&width=400"
  },
  "wholeRemote": {
    "title": "Original Whole Body remote",
    "description": "For the original WBCTD only.",
    "url": "https://getneuromd.com/products/whole-body-corrective-therapy-device-remote-replacement-part",
    "image": "https://cdn.shopify.com/s/files/1/0201/2450/0032/files/NMD-WBCTD-Replacement-Remote.png?v=1720018818&width=400"
  },
  "wholePod": {
    "title": "Original Whole Body pod",
    "description": "For the original WBCTD only.",
    "url": "https://getneuromd.com/products/whole-body-corrective-therapy-device-pod-replacement-part",
    "image": "https://cdn.shopify.com/s/files/1/0201/2450/0032/files/NMD-WBCTD-Replacement-Pod.png?v=1720018812&width=400"
  },
  "wholeCable": {
    "title": "Original Whole Body charging cable",
    "description": "For the original WBCTD only.",
    "url": "https://getneuromd.com/products/whole-body-corrective-therapy-device-charging-cable",
    "image": "https://cdn.shopify.com/s/files/1/0201/2450/0032/files/NMD-WBCTD-Replacement-ChargingCable.png?v=1720018824&width=400"
  },
  "whole2Remote": {
    "title": "Whole Body 2.0 remote",
    "description": "Compatible only with WBCTD 2.0.",
    "url": "https://getneuromd.com/products/whole-body-corrective-therapy-device-2-0-remote",
    "image": "https://cdn.shopify.com/s/files/1/0201/2450/0032/files/WBCTD2.0Remoteonly.png?v=1732546842&width=400"
  },
  "whole2Pod": {
    "title": "Whole Body 2.0 pod kit",
    "description": "Includes one pod, electrodes, and charging cable. Remote not included.",
    "url": "https://getneuromd.com/products/whole-body-corrective-therapy-device-2-0-device-pod",
    "image": "https://cdn.shopify.com/s/files/1/0201/2450/0032/files/WBCTD2.0deviceonly_1.png?v=1732545949&width=400"
  }
};
const replacementsByDevice={
  "back": {
    "electrodes": [
      "butterfly",
      "square"
    ],
    "parts": [
      "backRemote",
      "backPod",
      "backCable"
    ],
    "note": "The V4 USB-C remote and pod below are listed for devices ordered after July 4, 2023. For an earlier CTD or a different charge port, ask support to confirm the right part. Butterfly pads are listed for CTD devices purchased after August 28, 2019."
  },
  "whole2": {
    "electrodes": [
      "butterfly",
      "square"
    ],
    "parts": [
      "whole2Remote",
      "whole2Pod"
    ],
    "note": "These parts are for Whole Body 2.0. Original Whole Body remotes and pods are not interchangeable."
  },
  "whole": {
    "electrodes": [
      "wholePads"
    ],
    "parts": [
      "wholeRemote",
      "wholePod",
      "wholeCable"
    ],
    "note": "These electrodes and parts fit the original Whole Body device, not Whole Body 2.0."
  }
};

function renderParts(model){
 const selection=replacementsByDevice[model];
 const cards=keys=>keys.map(key=>{
   const p=replacementProducts[key];
   return `<article class="replacement-card"><img src="${p.image}" alt="${escapeText(p.title)}" width="400" height="400" loading="lazy"><div class="replacement-copy"><h4>${escapeText(p.title)}</h4><p>${escapeText(p.description)}</p><a href="${p.url}" target="_blank" rel="noopener">View product ↗</a></div></article>`;
 }).join('');
 document.getElementById('deviceParts').innerHTML=`<h2 id="partsHeading">Replacement parts & electrodes</h2><p class="parts-model">For your ${escapeText(deviceNames[model])}.</p><p class="parts-note">${escapeText(selection.note)}</p><h3>Electrodes</h3><div class="replacement-grid">${cards(selection.electrodes)}</div><h3>Replacement parts</h3><div class="replacement-grid">${cards(selection.parts)}</div><button type="button" class="text-button parts-help" data-chat="Please help me confirm which replacement part or electrodes fit my device.">Not sure which part fits? Ask support →</button>`;
}
